//Imports
import React from "react";
// import "./footer/footer.css"

//Footer Component
function Footer() {
    return (
        <footer className="techFooter"> </footer>
    )
}

//Exporting Footer component
export default Footer;

